import {
  base_colorAction,
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { flyout_outerBlockVSpacing, spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const header = css`
  margin-bottom: ${spacing(6)};
`

export const tabList = css`
  border-bottom: 1px solid ${base_colorContentBorder};
  display: flex;
  gap: ${spacing(6)};
  margin-bottom: ${flyout_outerBlockVSpacing};
`

export const tab = css`
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  color: ${text_colorTextSecondary};
  cursor: pointer;
  font-family: ${font_family_weight_medium};
  ${font_md};
  margin-bottom: -1px;
  padding: 0 0 ${spacing(3)};

  &[aria-selected='true'] {
    border-bottom-color: ${base_colorAction};
    color: ${text_colorTextPrimary};
  }

  &:focus-visible {
    border-radius: ${spacing(1)};
    outline: 2px solid ${base_colorAction};
    outline-offset: ${spacing(1)};
  }
`

export const panel = css`
  width: 100%;

  &[hidden] {
    display: none;
  }
`

export const overviewPanel = css`
  & > * {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
  }

  & > *:not(:last-child)::after {
    background: ${base_colorContentBorder};
    content: '';
    height: 1px;
    left: 0;
    margin: ${flyout_outerBlockVSpacing} 0;
    right: 0;
  }
`
